import React, { useCallback, useState, useEffect } from 'react'
import { useHistory } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import LayoutWithAccountCard from '../../../layout/Layout/layout-account-card'
import Loading from 'custom/assets/loaders/Loading'
import NumberFormat from 'react-number-format'
import NeoInput from '../../../components/NeoInput/NeoInput'
import InputError from '../../../components/InputError/InputError'
import NeoButton from '../../../components/NeoButton/NeoButton'
import Pagination from 'react-js-pagination'
import moment from 'moment'
import BeneficiaryTransferService from '../../../services/beneficiary-transfers.service'
import { RECIPTS_KEYS } from '../../../utils/translation-constants'
import { Formik, Form } from 'formik'
import { DownloadReceiptSchema } from '../../../schemas/others/downloadCenter/downloadReceipt'
import validationConfig from 'custom/config/validation.config.json'
import GimacService from '../../../services/gimac.service'
import '../../../styles/GimacReciepts.css'

const downloadReceipConfig = validationConfig['downloadCenter']['downloadReceipt']

export default function GimacReciepts() {
  const { t } = useTranslation()
  const history = useHistory()
  const [stage, setStage] = useState(0)
  const [expanded, setExpanded] = useState(null)
  const [loading, setLoading] = useState(false)
  const [receiptsList, setReceiptsList] = useState([])
  const [noRecords, setNoRecords] = useState(false)
  const [currentPage, setCurrentPage] = useState(1)
  const pageLimit = 10
  const [totalRecords, setTotalRecords] = useState(10)
  const [formValues, setFormValues] = useState({
    fromDate: '',
    toDate: '',
  })
  const [activeTab, setActiveTab] = useState('incoming');

  const lastNTransaction = useCallback(async (page, values, currentTab) => {
    try {
      setLoading(true);
      setReceiptsList([]);
      let reqParam = {
        module: 'GIMAC',
        fromDate: values?.fromDate || '',
        toDate: values?.toDate || '',
        page: page,
        size: pageLimit,
      };
      const response = currentTab === 'incoming'
        ? await GimacService.lastNTransactionIncoming(reqParam) : currentTab === "outgoing" ? await GimacService.lastNTransaction(reqParam) : await GimacService.lastNTransactionIncoming(reqParam)
      if (response.status === 200) {
        setNoRecords(response.data['receiptDetails'].length === 0 ? true : false);
        setReceiptsList(response.data['receiptDetails']);
        setTotalRecords(response.data['totalItems']);
      }
      setLoading(false);
    } catch (err) {
      setLoading(false);
    }
  }, [activeTab]);

  useEffect(() => {
    lastNTransaction(0, {},)
  }, [])

  const paginationChange = useCallback(
    async (page) => {
      setCurrentPage(page)
      await lastNTransaction(page - 1, formValues)
    },
    [formValues],
  )

  const onSearch = useCallback(async (values) => {
    if (values) {
      setFormValues({
        fromDate: values?.fromDate,
        toDate: values?.toDate,
      })
    }
    await lastNTransaction(0, values)
  }, [])

  const getDownload = useCallback(async (selected) => {
    try {
      setLoading(true)
      const reqParams = {
        transRefNum: selected.transactionRef,
        refId: selected.receiptId,
        module: 'GIMAC',
      }
      await GimacService.downLoadReport(reqParams)
      setLoading(false)
    } catch (err) {
      setLoading(false)
    }
  }, [])

  const handleTabChange = (tab) => {
    let currentTab = tab
    setActiveTab(tab);
    lastNTransaction(0, formValues, currentTab);
  };


  const tabOptions = [
    { value: 'incoming', label: 'Incoming Payments' },
    { value: 'outgoing', label: 'Outgoing Payments' },
  ];



  function renderLoading() {
    return (
      <div className='mx-4 rounded d-flex justify-content-center align-items-center'>
        <Loading width='50px' height='50px' />
      </div>
    )
  }

  function renderReciept() {
    return (
      <div style={{ justifyContent: ' space-between', alignItems: 'center' }}>
        {receiptsList.map((item, index) => (
          <div
            key={index}
            className='loan-card '
            onClick={() => (expanded === index ? setExpanded(null) : setExpanded(index))}>
            <div className='loan-header'>
              <div>
                <span>
                  {t(RECIPTS_KEYS.RECP_NO)} : {item.externalRef}
                </span>
                <div style={{ display: 'flex' }}>
                  <span>{t(RECIPTS_KEYS.TRANSACTION_DATE)}: </span>
                  <span style={{ marginLeft: 5 }}>
                    {moment(item.transTime).format('DD-MM-YYYY')} &nbsp;{''}
                    {moment(item.transTime).format('HH:MM:SS')}
                  </span>
                </div>
              </div>
              <div>
                <div className='d-flex' style={{ justifyContent: 'end' }}>
                  <label style={{ fontSize: '6px' }}>{item?.srcAccCcy}</label>
                  &nbsp;
                  <NumberFormat
                    value={item?.amount}
                    displayType={'text'}
                    thousandSeparator={true}
                    prefix={''}
                    className='float-right'
                    fixedDecimalScale={true}
                    decimalScale={2}
                    allowEmptyFormatting
                  />
                </div>
              </div>
            </div>
            {expanded === index && (
              <div className='loan-details'>
                <div className='row beneficiary-details justify-space-between '>
                  <div className='col-12'>
                    <div className='row'>
                      <div className='col-4'>
                        <div className='label'>{t(RECIPTS_KEYS.FROM_ACCOUNT)}</div>
                        <div className='value'>{item?.srcAccount}</div>
                      </div>

                      <div className='col-4'>
                        <div className='label'>{t(RECIPTS_KEYS.TO_ACCOUNT)}</div>
                        <div className='value'>{item?.destAccount}</div>
                      </div>

                      <div className='col-4'>
                        <div className='label'>{t(RECIPTS_KEYS.TRANSACTION_DATE)}</div>
                        <div className='value'>
                          {moment(item.transTime || '-').format('DD-MM-YYYY')} &nbsp;{' '}
                          {moment(item.transTime || '-').format('HH:MM:SS')}
                        </div>
                      </div>

                      <div className='col-4'>
                        <div className='label'>{t(RECIPTS_KEYS.TRANS_CURRENCY)}</div>
                        <div className='value'>{item?.txnCurrency}</div>
                      </div>

                      <div className='col-4'>
                        <div className='label'>{t(RECIPTS_KEYS.AMOUNT)}</div>
                        <div className=' d-flex value'>
                          <NumberFormat
                            value={item?.amount}
                            displayType={'text'}
                            thousandSeparator={true}
                            prefix={''}
                            fixedDecimalScale={true}
                            decimalScale={2}
                            allowEmptyFormatting
                          />
                        </div>
                      </div>

                      <div className='col-4'>
                        <div className='label'>{t(RECIPTS_KEYS.REF_ID)}</div>
                        <div className='value'>{item?.transactionRef}</div>
                      </div>
                      <div className='col-4'>
                        <div className='label'>{t(RECIPTS_KEYS.PAYMENT_TYPE)}</div>
                        <div className='value'>{item?.paymentType}</div>
                      </div>
                      {activeTab !== 'incoming' &&
                        <div className='col-4'>
                          <div className='label'>{t(RECIPTS_KEYS.REMARKS)}</div>
                          <div className='value'>{item?.remarks}</div>
                        </div>}
                      <div className='col-4'>
                        <div className='label'>{t(RECIPTS_KEYS.STATUS)}</div>
                        <div className='value'>{item?.paymentStatus}</div>
                      </div>

                    </div>

                    <div class='row'>
                      <h6
                        className='download-link'
                        onClick={(e) => {
                          e.preventDefault()
                          e.stopPropagation()
                          getDownload(item)
                        }}>
                        {t(RECIPTS_KEYS.DOWNLOAD)}
                      </h6>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
        ))}
      </div>
    )
  }

  return (
    <LayoutWithAccountCard
      breadCumKey='GIMAC_RECIEPTS'
      keyPath={'GIMAC_RECIEPTS'}
      showEmptySpace={true}>
      <div className='mb-4'>
        <Formik
          initialValues={formValues}
          validationSchema={DownloadReceiptSchema}
          onSubmit={onSearch}>
          {({ isSubmitting, errors, touched, handleChange, values }) => (
            <Form>
              <div className='row'>
                <div className='form-group col-4 p-0 mx-3'>
                  <NeoInput
                    showAsterisk={downloadReceipConfig['isFromDateRequired']}
                    text={t(RECIPTS_KEYS.FORM_DATE)}
                    name='fromDate'
                    type='date'
                    onChange={handleChange}
                    max={moment(new Date()).format('YYYY-MM-DD')}
                  //value={values.fromDate}
                  />
                  <InputError text={errors.fromDate} touched={touched.fromDate} />
                </div>
                <div className='form-group col-4 p-0 mx-3'>
                  <NeoInput
                    showAsterisk={downloadReceipConfig['isToDateRequired']}
                    text={t(RECIPTS_KEYS.TO_DATE)}
                    name='toDate'
                    type='date'
                    onChange={handleChange}
                    max={moment(new Date()).format('YYYY-MM-DD')}
                  //value={values.toDate}
                  />
                  <InputError text={errors.toDate} touched={touched.toDate} />
                </div>
                <div className='col-2 p-0' style={{ marginTop: '30px' }}>
                  <NeoButton type='submit' text={t(RECIPTS_KEYS.SEARCH)} mode='newDesign' />
                </div>
              </div>
            </Form>
          )}
        </Formik>
      </div>
      <div className='tab-buttons'>
        {tabOptions.map((tabOption) => (
          <button
            key={tabOption.value}
            className={`tab-button ${activeTab === tabOption.value ? 'active' : ''}`}
            onClick={() => handleTabChange(tabOption.value)}>
            {tabOption.label}
          </button>
        ))}
      </div>
      <div className='receipt-section'>
        {loading && renderLoading()}

        {renderReciept()}

        {noRecords && <div className='no-data-found'>{t(RECIPTS_KEYS.NORECEIPTS)} </div>}
      </div>
      <div className='d-flex justify-content-center mb-5 mt-2'>
        {!loading && receiptsList?.length > 0 && (
          <Pagination
            activePage={currentPage}
            itemsCountPerPage={pageLimit}
            totalItemsCount={totalRecords}
            pageRangeDisplayed={5}
            itemClass='page-item'
            linkClass='page-link'
            onChange={paginationChange}
          />
        )}
      </div>
    </LayoutWithAccountCard>
  )
}
